{
  "feedback-internal-success-page": {
    "buttons": {
      "to-salon": "TO SALON"
    },
    "text": {
      "thanks": "Thank you for your feedback",
      "thanks-again": "Your feedback is very valuable to help us improve our service"
    }
  }
}
